import { makeStyles } from '@material-ui/core/styles';

import { COLOR_GREEN_ACTIVE, COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    wrapper: {
      display: 'flex',
      position: 'relative',
      alignItems: 'center',
      flexDirection: 'column',
    },
    root: {
      position: 'relative',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      width: 64,
      height: 64,

      transform: 'rotate(180deg)',
    },
    clickable: {},
    circleBgRoot: {
      position: 'absolute',
    },
    circleBgCircle: {
      stroke: COLORS.gray.gray60,
      strokeWidth: '3px',
    },
    circleRoot: {
      position: 'absolute',
    },
    circleCircle: {
      stroke: COLOR_GREEN_ACTIVE,
      strokeWidth: '3px',
    },
    circleLoading: {
      position: 'absolute',

      '& circle': {
        strokeWidth: '3px',
      },
    },

    circleLoadingGray: {
      color: COLORS.gray.gray60,
    },

    score: {
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.neutral.secondary,
    },
    progress: {
      width: '100%',
      height: '100%',
    },
    progressNumber: {
      position: 'absolute',
      top: 24,
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
    },
    progressOutOf: {
      display: 'inline',
      color: COLORS.gray.gray40,
    },
    progressLineLabel: {
      position: 'absolute',
      top: 32,
      left: -2,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      color: COLORS.gray.gray40,
    },
    progressLine: {
      width: 9,
      height: 2,
      backgroundColor: COLORS.gray.gray30,
    },
    progressInfo: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      bottom: -14,
      borderRadius: theme.shape.borderRadiusLarge,
      border: '4px solid #FAFAFA',
      backgroundColor: COLORS.neutral.white,
    },
    progressIcon: {
      fontSize: theme.typography.pxToRem(12),
      color: COLORS.gray.black,
    },
    thumbsDownIcon: {
      transform: 'rotate(180deg)',
    },
    progressCount: {
      borderRadius: theme.shape.borderRadiusLarge,
      border: theme.shape.borderGray60,
      color: COLORS.gray.gray30,
      padding: theme.spacing(0.5, 1),
      backgroundColor: COLORS.neutral.white,
      fontWeight: theme.typography.fontWeightSemiBold,
      width: 32,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: theme.shape.boxShadowMedium,
    },
  }),
  { name: 'RatingsScore' }
);
